export type IAppPerformanceSurveyController = ReturnType<
  typeof AppPerformanceSurveyControllerFactory
>;

export const AppPerformanceSurveyControllerFactory = ({
  appPerformanceSurveyService,
}: {
  appPerformanceSurveyService: IAppPerformanceSurveyService;
}) => {
  const storeAppPerformanceSurvey = async (payload: {
    rating: number;
    note?: string;
    email?: string;
    facilityName?: string;
  }) => {
    return await appPerformanceSurveyService.storeAppPerformanceSurvey(payload);
  };

  return {
    storeAppPerformanceSurvey,
  };
};
